import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../Errors/InvalidParamsSharedError.js'
import {StringSharedValueObject} from './StringSharedValueObject.js'

export class IdSharedValueObject extends ValueObject {
  #id

  static IS_VALID = true
  static NOT_VALID = false

  constructor({id}) {
    super()
    this.#id = id
  }

  static empty() {
    return new IdSharedValueObject({id: StringSharedValueObject.empty()})
  }

  static safeValidate({id}) {
    try {
      IdSharedValueObject.validate({id})
      return IdSharedValueObject.IS_VALID
    } catch {
      return IdSharedValueObject.NOT_VALID
    }
  }

  static validate({id}) {
    if (id === null || id === undefined) {
      throw InvalidParamsSharedError.create(`[IdSharedValueObject.validate] id is required`)
    }
  }

  static createFromPrimitives({id}) {
    IdSharedValueObject.validate({id})
    return new IdSharedValueObject({id: StringSharedValueObject.create({value: id})})
  }

  get id() {
    return this.#id.value
  }

  get value() {
    return this.id
  }

  isEmpty() {
    return this.#id.isEmpty()
  }

  toPrimitives() {
    return {
      id: this.#id.toPrimitives()
    }
  }
}
